// Assessment API Configuration
export const ASSESSMENT_API_CONFIG = {
  BASE_URL: `${import.meta.env.VITE_API_BASE_URL}/food_scanner`,
  TENANT_ID: "ab9bb443-b2ef-4b55-b0ed-0b4a41bb2dc8",
  TIMEOUT: 30000, // 30 seconds
  RETRY_COUNT: 3,
  RETRY_DELAY_BASE: 1000, // 1 second base delay

  ENDPOINTS: {
    NEW_ASSESSMENT: "/new-assessment/",
    TEST_CONNECTION: "/",
  },

  DEFAULTS: {
    GENDER: "male",
    RACE: "asian",
    AGE: 26,
    HEIGHT_UNIT: "ft_in",
    HEIGHT_FT: 4,
    HEIGHT_INCHES: 4,
    HEIGHT_CM: 0,
    WEIGHT_UNIT: "kg",
    WEIGHT_KG: 44,
    WEIGHT_LBS: 0,
    DIABETES_TYPE: "prediabetic",
    WEIGHT_LOSS_GOAL: "no",
    WEIGHT_LOSS_REASONS: "General health / feel better", // Only used as fallback when weight_loss_goal is 'yes'
    ACTIVITY_LEVEL: "sedentary",
    DIET_ADHERENCE: "vegetarian",
    INTERMITTENT_FASTING: "No — I eat throughout the day",
    FASTING_WINDOW_TYPE: "16:8 (Fast 16 hrs / Eat 8 hrs)",
    MEAL_TIMES: ["01:00"],
    IS_COMPLETED: false,
    MEDICATION_DETAILS: [
      {
        name: "gbhvg",
        dose: "500mg",
        frequency: "fghh",
        time: "5:23",
        quantity: 45,
      },
    ],
    INSULIN_DETAILS: [],
  },

  VALIDATION: {
    HEIGHT_FT_MIN: 4,
    HEIGHT_FT_MAX: 7,
    WEIGHT_KG_MIN: 40,
    WEIGHT_KG_MAX: 200,
    AGE_MIN: 18,
    AGE_MAX: 100,
  },
} as const;

// Helper function to get assessment endpoints
export const getAssessmentEndpoints = () => ({
  newAssessment: `${ASSESSMENT_API_CONFIG.BASE_URL}${ASSESSMENT_API_CONFIG.ENDPOINTS.NEW_ASSESSMENT}`,
  testConnection: `${ASSESSMENT_API_CONFIG.BASE_URL}${ASSESSMENT_API_CONFIG.ENDPOINTS.TEST_CONNECTION}`,
});

// Type-safe config getters
export const getAssessmentConfig = () => ASSESSMENT_API_CONFIG;
